<div class="menubar-hoverable header-fixed menubar-pin" style="
    font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;
    font-size: 13px;
    line-height: 1.846153846;
    color: #313534;
    background-color: #ffffff;
  ">

  <div id="base">
    <div class="offcanvas"></div>
    <!--end .offcanvas-->

    <div id="content">
      <section class="dv2-section">

        <!-- Metric cards skeleton -->
        <div class="dv2-metrics" *ngIf="loaderMetrics">
          <div class="dv2-metric-card" *ngFor="let cell of [1,2,3,4]">
            <p-skeleton shape="circle" size="38px"></p-skeleton>
            <div class="dv2-metric-text">
              <p-skeleton width="60%" height="0.75rem" styleClass="dv2-skeleton-label"></p-skeleton>
            </div>
            <p-skeleton width="30px" height="1.75rem" styleClass="dv2-skeleton-value"></p-skeleton>
          </div>
        </div>

        <!-- Metric cards — static display (no hover/navigation; see
             dashboard-v2.component.css for the tint tokens). The
             "Last: X Days Ago" subheading pattern (lastBroadcastLabel) is
             wired up but has no backing field in dashboardMetrices yet, so
             it never renders today — *ngIf keeps it ready for whenever
             that data exists, rather than being fabricated. -->
        <div class="dv2-metrics" *ngIf="!loaderMetrics">
          <div class="dv2-metric-card" [class.dv2-metric-clickable]="permissions.SCHOOL_STUDENT_MANAGEMENT == 'ENABLED'" (click)="permissions.SCHOOL_STUDENT_MANAGEMENT == 'ENABLED' && navigateTo('groups', null)">
            <div class="dv2-metric-icon dv2-metric-icon-teal"><i class="ph ph-users-three"></i></div>
            <div class="dv2-metric-text">
              <p class="dv2-metric-label">{{ 'dv2StatStudents' | translate }}</p>
            </div>
            <strong class="dv2-metric-value" [countUp]="totalStudents"></strong>
          </div>

          <div class="dv2-metric-card" [class.dv2-metric-clickable]="permissions.BROADCAST_VIEW == 'ENABLED'" (click)="permissions.BROADCAST_VIEW == 'ENABLED' && navigateTo('broadcast', null)">
            <div class="dv2-metric-icon dv2-metric-icon-amber"><i class="ph ph-megaphone"></i></div>
            <div class="dv2-metric-text">
              <p class="dv2-metric-label">{{ 'dv2StatBroadcastsSent' | translate }}</p>
              <p class="dv2-metric-sub" *ngIf="lastBroadcastLabel">{{ lastBroadcastLabel }}</p>
            </div>
            <strong class="dv2-metric-value" [countUp]="totalBroadcast"></strong>
          </div>

          <div class="dv2-metric-card" [class.dv2-metric-clickable]="permissions.SCHOOL_STAFFS_MANAGEMENT == 'ENABLED'" (click)="permissions.SCHOOL_STAFFS_MANAGEMENT == 'ENABLED' && navigateTo('groups', 'staffs')">
            <div class="dv2-metric-icon dv2-metric-icon-blue"><i class="ph ph-identification-badge"></i></div>
            <div class="dv2-metric-text">
              <p class="dv2-metric-label">{{ 'dv2StatStaff' | translate }}</p>
            </div>
            <strong class="dv2-metric-value" [countUp]="totalStaffs"></strong>
          </div>

          <div class="dv2-metric-card" [class.dv2-metric-clickable]="permissions.CLASS_MANAGEMENT == 'ENABLED'" (click)="permissions.CLASS_MANAGEMENT == 'ENABLED' && navigateTo('class', null)">
            <div class="dv2-metric-icon dv2-metric-icon-rose"><i class="ph ph-chalkboard"></i></div>
            <div class="dv2-metric-text">
              <p class="dv2-metric-label">{{ 'dv2StatClasses' | translate }}</p>
            </div>
            <strong class="dv2-metric-value" [countUp]="totalClasses"></strong>
          </div>
        </div>

        <!-- Tabbed activity card -->
        <div class="dv2-card">
          <div class="dv2-tabs">
            <button *ngIf="permissions.VIEW_NEW_ADMISSIONS == 'ENABLED'" type="button"
              class="dv2-tab" [class.active]="activeTab === 'admissions'" (click)="setActiveTab('admissions')">
              {{ 'newAdmissions' | translate }}
            </button>
            <button *ngIf="permissions.VIEW_SCHOOL_DAY_STATUS == 'ENABLED'" type="button"
              class="dv2-tab" [class.active]="activeTab === 'schoolStatus'" (click)="setActiveTab('schoolStatus')">
              {{ 'dailySchoolStatus' | translate }}
            </button>
            <button *ngIf="onlinePaymentHistory == 'ENABLED'" type="button"
              class="dv2-tab" [class.active]="activeTab === 'onlinePayments'" (click)="setActiveTab('onlinePayments')">
              {{ 'onlinePayments' | translate }}
            </button>
            <button *ngIf="brand.appStatusTabEnabled" type="button" class="dv2-tab" [class.active]="activeTab === 'appStatus'" (click)="setActiveTab('appStatus')">
              {{ 'bluewingsAppStatus' | translate:{ brandName: brand.name } }}
            </button>

            <div class="dv2-table-actions" *ngIf="activeTab === 'admissions' && !noresultadmission">
              <div class="dv2-copy-wrap">
                <button type="button" class="dv2-btn dv2-btn-copy" (click)="copyAdmissionsToClipboard()">
                  <i class="fa fa-files-o"></i> {{ 'dataTables.buttons.copy' | translate }}
                </button>
                <span class="dv2-copy-toast" *ngIf="admissionCopyStatus === 'copied'">
                  {{ getNewAdmissionListArray.length }} {{ 'rowsCopiedToClipboard' | translate }}
                </span>
              </div>
              <button type="button" class="dv2-btn dv2-btn-export" (click)="exportAdmissionsToExcel()">
                <i class="fa fa-file-excel-o"></i> {{ 'exportExcel' | translate }}
              </button>
            </div>
          </div>

          <div class="dv2-tab-body">

            <!-- New Admissions -->
            <div *ngIf="activeTab === 'admissions'">
              <div class="dv2-toolbar">
                <h4 class="dv2-toolbar-title">{{ 'listOfNewAdmissions' | translate }}</h4>
                <div class="dv2-radio-group">
                  <label class="dv2-radio">
                    <input type="radio" name="new-admission" checked (click)="admissionByClick(true)" />
                    <span>{{ 'allNewAdmissions' | translate }}</span>
                  </label>
                  <label class="dv2-radio">
                    <input type="radio" name="new-admission" (click)="admissionByClick(false)" />
                    <span>{{ 'newAdmissionByDate' | translate }}</span>
                  </label>
                </div>
              </div>

              <form class="dv2-filter-row" *ngIf="!admissionByStatus">
                <label class="dv2-filter-label">{{ 'newAdmissionByDateLabel' | translate }}</label>
                <input type="date" class="dv2-input" [(ngModel)]="admissionDateFilter" name="admissionDateFilter" />
                <button type="button" class="dv2-btn dv2-btn-primary" (click)="viewAdmissionByDate()">
                  {{ 'viewAdmissions' | translate }}
                </button>
              </form>

              <form class="dv2-filter-row" *ngIf="admissionByStatus">
                <label class="dv2-filter-label">{{ 'filterStudentsBy' | translate }}</label>
                <select class="dv2-select" [(ngModel)]="selectedCategory" [ngModelOptions]="{standalone: true}"
                  (change)="getCategoryFunction($event.target.value)">
                  <option value="0">{{ 'allCategories' | translate }}</option>
                  <option *ngFor="let category of schoolCategories" value="{{ category.categoryId }}">
                    {{ category.categoryName }}
                  </option>
                </select>
                <select class="dv2-select" [(ngModel)]="selectedClass" [ngModelOptions]="{standalone: true}"
                  [disabled]="selectClassStatus" (change)="selectClassFunction($event.target.value)">
                  <option value="0">{{ 'selectClass' | translate }}</option>
                  <option *ngFor="let cl of schoolClasses" value="{{ cl.classid }}">{{ cl.classname }}</option>
                </select>
                <select class="dv2-select" [(ngModel)]="selectedSection" [ngModelOptions]="{standalone: true}"
                  [disabled]="selectClassSectionStatus" (change)="selectSectionFunction($event.target.value)">
                  <option value="0">{{ 'selectSection' | translate }}</option>
                  <option *ngFor="let section of schoolClassesSections" value="{{ section.claaSectionId }}">
                    {{ section.classSection }}
                  </option>
                </select>
              </form>

              <div *ngIf="loaderadmission" class="dv2-table-wrap">
                <table class="dv2-table">
                  <thead>
                    <tr>
                      <th>{{ 'student' | translate }}</th>
                      <th>{{ 'studentClass' | translate }}</th>
                      <th>{{ 'dateOfAdmission' | translate }}</th>
                      <th>{{ 'admissionNo' | translate }}</th>
                      <th>{{ 'father' | translate }}</th>
                      <th>{{ 'mother' | translate }}</th>
                      <th>{{ 'dateOfBirth' | translate }}</th>
                      <th>{{ 'phone' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cell of skeletonRows">
                      <td>
                        <div class="dv2-student-cell">
                          <p-skeleton shape="circle" size="2rem"></p-skeleton>
                          <p-skeleton width="90px" height="0.85rem"></p-skeleton>
                        </div>
                      </td>
                      <td><p-skeleton width="50px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="70px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="70px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="80px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="80px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="70px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="80px" height="0.85rem"></p-skeleton></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div *ngIf="!loaderadmission && noresultadmission" class="dv2-admission-empty">
                <div class="dv2-admission-empty-icon-wrap">
                  <span class="dv2-admission-empty-dot dv2-admission-empty-dot-1"></span>
                  <span class="dv2-admission-empty-dot dv2-admission-empty-dot-2"></span>
                  <span class="dv2-admission-empty-dot dv2-admission-empty-dot-3"></span>
                  <div class="dv2-admission-empty-ring">
                    <i class="ph-bold ph-user-plus"></i>
                  </div>
                </div>
                <h3 class="dv2-admission-empty-title">{{ 'header.noAdmissionsFound' | translate }}</h3>
                <p class="dv2-admission-empty-text" *ngIf="hasAdmissionFilters">
                  {{ 'header.noAdmissionsMatchingFilterPart1' | translate }}
                  <strong>{{ admissionCategoryLabel || admissionClassLabel || admissionSectionLabel }}</strong>
                  {{ 'header.noAdmissionsMatchingFilterPart2' | translate }}
                </p>
                <p class="dv2-admission-empty-text" *ngIf="!hasAdmissionFilters">
                  {{ 'header.noAdmissionsYet' | translate }}
                </p>
                <div class="dv2-admission-empty-chips" *ngIf="hasAdmissionFilters">
                  <span class="dv2-admission-empty-chip">{{ 'header.category' | translate }}: <strong>{{ admissionCategoryLabel || ('header.any' | translate) }}</strong></span>
                  <span class="dv2-admission-empty-chip">{{ 'header.class' | translate }}: <strong>{{ admissionClassLabel || ('header.any' | translate) }}</strong></span>
                  <span class="dv2-admission-empty-chip">{{ 'header.section' | translate }}: <strong>{{ admissionSectionLabel || ('header.any' | translate) }}</strong></span>
                </div>
                <div class="dv2-admission-empty-actions">
                  <button type="button" class="dv2-btn dv2-btn-secondary" *ngIf="hasAdmissionFilters" (click)="clearAdmissionFilters()">
                    <i class="ph-bold ph-arrow-counter-clockwise"></i> {{ 'header.clearFilters' | translate }}
                  </button>
                  <button type="button" class="dv2-btn dv2-btn-primary" data-toggle="modal" data-target="#newadmission-v2">
                    <i class="ph-bold ph-plus"></i> {{ 'header.new' | translate }} {{ 'header.admission' | translate }}
                  </button>
                </div>
              </div>

              <div *ngIf="!loaderadmission && !noresultadmission" class="dv2-table-wrap">
                <table class="dv2-table">
                  <thead>
                    <tr>
                      <th>{{ 'student' | translate }}</th>
                      <th>{{ 'studentClass' | translate }}</th>
                      <th class="dv2-th-sortable" (click)="sortAdmissionsBy('dateOfAdmission')">
                        {{ 'dateOfAdmission' | translate }}
                        <i class="fa" [ngClass]="admissionSortColumn === 'dateOfAdmission' ? (admissionSortDirection === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
                      </th>
                      <th class="dv2-th-sortable" (click)="sortAdmissionsBy('registrationId')">
                        {{ 'admissionNo' | translate }}
                        <i class="fa" [ngClass]="admissionSortColumn === 'registrationId' ? (admissionSortDirection === 'asc' ? 'fa-sort-asc' : 'fa-sort-desc') : 'fa-sort'"></i>
                      </th>
                      <th>{{ 'father' | translate }}</th>
                      <th>{{ 'mother' | translate }}</th>
                      <th>{{ 'dateOfBirth' | translate }}</th>
                      <th>{{ 'phone' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let student of pagedAdmissionList" [rowEntrance]="student.registrationId + admissionPage">
                      <td>
                        <div class="dv2-student-cell">
                          <img class="dv2-student-avatar"
                               [src]="student.studentImage || 'https://s3-us-west-2.amazonaws.com/bluewingsfilestorage/BluewingsEnterprise/student_default_boy.png'"
                               alt="" />
                          <span>{{ student.studentName }}</span>
                        </div>
                      </td>
                      <td>{{ student.classNumber }}-{{ student.classDivision }}</td>
                      <td>{{ student.dateOfAdmission | date : 'MMM dd, yyyy' }}</td>
                      <td>{{ student.registrationId }}</td>
                      <td>{{ student.parentName }}</td>
                      <td>{{ student.motherName || '' }}</td>
                      <td>{{ student.dateOfBirth | date : 'MMM dd, yyyy' }}</td>
                      <td>{{ student.mobileNumber }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="dv2-pagination" *ngIf="!noresultadmission && admissionTotalPages > 1">
                <button type="button" class="dv2-page-btn" [disabled]="admissionPage === 1" (click)="goToAdmissionPage(admissionPage - 1)">
                  <i class="fa fa-angle-left"></i>
                </button>
                <span class="dv2-page-info">{{ admissionPage }} / {{ admissionTotalPages }}</span>
                <button type="button" class="dv2-page-btn" [disabled]="admissionPage === admissionTotalPages" (click)="goToAdmissionPage(admissionPage + 1)">
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>

            <!-- Daily School Status -->
            <div *ngIf="activeTab === 'schoolStatus'">
              <div class="dv2-toolbar">
                <h4 class="dv2-toolbar-title">{{ 'listOfSchoolActivities' | translate }}</h4>
              </div>
              <form class="dv2-filter-row">
                <label class="dv2-filter-label">{{ 'activitiesByDate' | translate }}:</label>
                <input type="date" class="dv2-input" [(ngModel)]="schoolActivityDateFilter" name="schoolActivityDateFilter" />
                <button type="button" class="dv2-btn dv2-btn-primary" (click)="viewSchoolActivityByDate()">
                  {{ 'viewActivities' | translate }}
                </button>
              </form>

              <div *ngIf="loaderactivity" class="dv2-table-wrap">
                <table class="dv2-table">
                  <thead>
                    <tr>
                      <th>{{ 'className' | translate }}</th>
                      <th>{{ 'classTeachers' | translate }}</th>
                      <th>{{ 'attendance' | translate }}</th>
                      <th>{{ 'conversations' | translate }}</th>
                      <th>{{ 'activityPosted' | translate }}</th>
                      <th>{{ 'diaries' | translate }}</th>
                      <th>{{ 'feesCollection' | translate }} ({{ schoolCurrency }})</th>
                      <th>{{ 'totalStudents' | translate }}</th>
                      <th>{{ 'activeParents' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let cell of skeletonRows">
                      <td><p-skeleton width="60px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="90px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="50px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="50px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="50px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="50px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="70px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="50px" height="0.85rem"></p-skeleton></td>
                      <td><p-skeleton width="50px" height="0.85rem"></p-skeleton></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div *ngIf="!loaderactivity" class="dv2-table-wrap">
                <table class="dv2-table">
                  <thead>
                    <tr>
                      <th>{{ 'className' | translate }}</th>
                      <th>{{ 'classTeachers' | translate }}</th>
                      <th>{{ 'attendance' | translate }}</th>
                      <th>{{ 'conversations' | translate }}</th>
                      <th>{{ 'activityPosted' | translate }}</th>
                      <th>{{ 'diaries' | translate }}</th>
                      <th>{{ 'feesCollection' | translate }} ({{ schoolCurrency }})</th>
                      <th>{{ 'totalStudents' | translate }}</th>
                      <th>{{ 'activeParents' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let activity of pagedSchoolStatusList" class="dv2-row-clickable" (click)="viewActivityDetail(
                          activity.classId, activity.classNumber, activity.classDivision, activity.totalStudents,
                          activity.totalAttendanceCount, activity.feesCollection, activity.diaries,
                          activity.classTeacherName, activity.secondClassTeacherName, activity.thirdClassTeacherName)">
                      <td>{{ activity.classNumber }}-{{ activity.classDivision }}</td>
                      <td>
                        <span *ngIf="activity.classTeacherName && activity.secondClassTeacherName && activity.thirdClassTeacherName; else noTeachers">
                          {{ activity.classTeacherName }}<br />{{ activity.secondClassTeacherName }}<br />{{ activity.thirdClassTeacherName }}
                        </span>
                        <ng-template #noTeachers>-</ng-template>
                      </td>
                      <td>{{ activity.totalAttendanceCount }}</td>
                      <td>{{ activity.prentToStaffChat }} <i class="fa fa-arrows-h"></i> {{ activity.staffToPrentChat }}</td>
                      <td>{{ activity.activityShared }} {{ 'activities' | translate }}</td>
                      <td>{{ activity.diaries }}</td>
                      <td>{{ activity.feesCollection ? activity.feesCollection : '-' }}</td>
                      <td>{{ activity.totalStudents }}</td>
                      <td>{{ activity.activeParents }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="dv2-pagination" *ngIf="schoolStatusTotalPages > 1">
                <button type="button" class="dv2-page-btn" [disabled]="schoolStatusPage === 1" (click)="goToSchoolStatusPage(schoolStatusPage - 1)">
                  <i class="fa fa-angle-left"></i>
                </button>
                <span class="dv2-page-info">{{ schoolStatusPage }} / {{ schoolStatusTotalPages }}</span>
                <button type="button" class="dv2-page-btn" [disabled]="schoolStatusPage === schoolStatusTotalPages" (click)="goToSchoolStatusPage(schoolStatusPage + 1)">
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>

            <!-- Online Payments -->
            <div *ngIf="activeTab === 'onlinePayments'">
              <div class="dv2-toolbar">
                <h4 class="dv2-toolbar-title">{{ 'onlinePaymentHistory' | translate }}</h4>
                <div class="dv2-radio-group">
                  <label class="dv2-radio">
                    <input type="radio" name="pay-history" checked (click)="paymentHistoryByClick(true)" />
                    <span>{{ 'paymentByDay' | translate }}</span>
                  </label>
                  <label class="dv2-radio">
                    <input type="radio" name="pay-history" (click)="paymentHistoryByClick(false)" />
                    <span>{{ 'paymentByDuration' | translate }}</span>
                  </label>
                </div>
              </div>

              <form class="dv2-filter-row" *ngIf="paymentHistoryByStatus">
                <label class="dv2-filter-label">{{ 'selectDate' | translate }}</label>
                <input type="date" class="dv2-input" [(ngModel)]="onlineFeeSingleDate" name="onlineFeeSingleDate" />
                <button type="button" class="dv2-btn dv2-btn-primary" (click)="getOnlineFeePayCollection(paymentHistoryByStatus)">
                  {{ 'viewDetails' | translate }}
                </button>
              </form>

              <form class="dv2-filter-row" *ngIf="!paymentHistoryByStatus">
                <label class="dv2-filter-label">{{ 'from' | translate }}</label>
                <input type="date" class="dv2-input" [(ngModel)]="onlineFeeStartDate" name="onlineFeeStartDate" />
                <label class="dv2-filter-label">{{ 'to' | translate }}</label>
                <input type="date" class="dv2-input" [(ngModel)]="onlineFeeEndDate" name="onlineFeeEndDate" />
                <button type="button" class="dv2-btn dv2-btn-primary" (click)="getOnlineFeePayCollection(paymentHistoryByStatus)">
                  {{ 'viewDetails' | translate }}
                </button>
              </form>

              <div class="dv2-table-wrap">
                <table class="dv2-table">
                  <thead>
                    <tr>
                      <th>{{ 'studentName' | translate }}</th>
                      <th>{{ 'registrationId' | translate }}</th>
                      <th>{{ 'parent' | translate }}</th>
                      <th>{{ 'class' | translate }}</th>
                      <th>{{ 'amount' | translate }}</th>
                      <th>{{ 'purpose' | translate }}</th>
                      <th>{{ 'refId' | translate }}</th>
                      <th>{{ 'transactionOn' | translate }}</th>
                      <th>{{ 'transactionStatus' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let pay of onlineFeeCollection">
                      <td>{{ pay.studentName }}</td>
                      <td>{{ pay.registrationId ? pay.registrationId : '-' }}</td>
                      <td>{{ pay.parentName }}</td>
                      <td>{{ pay.classNumber }} - {{ pay.classDivision }}</td>
                      <td>₹{{ pay.Amount }}</td>
                      <td>{{ pay.Purpose }}</td>
                      <td>{{ pay.PaymentId ? pay.PaymentId : '-' }}</td>
                      <td>{{ pay.PaymentRequestOn | date : 'yMMMd' }}</td>
                      <td>{{ pay.PaymentStatus ? pay.PaymentStatus : ('pending' | translate) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Bluewings App Status -->
            <div *ngIf="activeTab === 'appStatus' && brand.appStatusTabEnabled">
              <div class="dv2-app-status-grid">
                <div class="dv2-app-status-card">
                  <div class="dv2-app-status-head">
                    <img *ngIf="brand.id" [src]="brand.logoPath" alt="{{ brand.name }} Staff App" class="dv2-app-status-logo">
                    <div>
                      <h2>{{ 'bluewingsStaffAppVersion' | translate:{ brandName: brand.name } }}</h2>
                      <span class="dv2-version">{{ 'v' | translate }} {{ staffAppAndroidVersion }}</span>
                    </div>
                  </div>
                  <div class="dv2-gauge-row">
                    <div class="dv2-gauge">
                      <svg viewBox="0 0 120 68" class="dv2-gauge-svg">
                        <path d="M 10 60 A 50 50 0 0 1 110 60" class="dv2-gauge-track"></path>
                        <path d="M 10 60 A 50 50 0 0 1 110 60" class="dv2-gauge-fill"
                          [style.stroke-dasharray]="157"
                          [style.stroke-dashoffset]="157 - (157 * staffAppAdoptionPercent / 100)"></path>
                      </svg>
                      <div class="dv2-gauge-label">
                        <span class="dv2-gauge-percent">{{ staffAppAdoptionPercent }}%</span>
                        <span class="dv2-gauge-caption">{{ 'adoption' | translate }}</span>
                      </div>
                    </div>
                    <div class="dv2-gauge-legend">
                      <div class="dv2-legend-item">
                        <span class="dv2-legend-dot dv2-legend-dot-active"></span>
                        <strong>{{ activeStaffAppUser }}</strong>
                        <span>{{ 'activeStaffs' | translate }}</span>
                      </div>
                      <div class="dv2-legend-item">
                        <span class="dv2-legend-dot dv2-legend-dot-inactive"></span>
                        <strong>{{ inActiveStaffAppUser }}</strong>
                        <span>{{ 'inactiveStaffs' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="dv2-app-status-card">
                  <div class="dv2-app-status-head">
                    <img *ngIf="brand.id" [src]="brand.logoPath" alt="{{ brand.name }} Parent App" class="dv2-app-status-logo">
                    <div>
                      <h2>{{ 'bluewingsParentAppVersion' | translate:{ brandName: brand.name } }}</h2>
                      <span class="dv2-version">{{ 'v' | translate }} {{ parentAppAndroidVersion }}</span>
                    </div>
                  </div>
                  <div class="dv2-gauge-row">
                    <div class="dv2-gauge">
                      <svg viewBox="0 0 120 68" class="dv2-gauge-svg">
                        <path d="M 10 60 A 50 50 0 0 1 110 60" class="dv2-gauge-track"></path>
                        <path d="M 10 60 A 50 50 0 0 1 110 60" class="dv2-gauge-fill"
                          [style.stroke-dasharray]="157"
                          [style.stroke-dashoffset]="157 - (157 * parentAppAdoptionPercent / 100)"></path>
                      </svg>
                      <div class="dv2-gauge-label">
                        <span class="dv2-gauge-percent">{{ parentAppAdoptionPercent }}%</span>
                        <span class="dv2-gauge-caption">{{ 'adoption' | translate }}</span>
                      </div>
                    </div>
                    <div class="dv2-gauge-legend">
                      <div class="dv2-legend-item">
                        <span class="dv2-legend-dot dv2-legend-dot-active"></span>
                        <strong>{{ activeParentAppUser }}</strong>
                        <span>{{ 'activeParents' | translate }}</span>
                      </div>
                      <div class="dv2-legend-item">
                        <span class="dv2-legend-dot dv2-legend-dot-inactive"></span>
                        <strong>{{ inActiveParentAppUser }}</strong>
                        <span>{{ 'inactiveParents' | translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>
    </div>


    <!-- View Activity slide-over panel -->
    <div class="dv2-overlay" *ngIf="showActivityDetail" (click)="closeActivityDetail()"></div>
    <div class="dv2-drawer" [class.open]="showActivityDetail">
      <div class="dv2-drawer-head">
        <button class="dv2-drawer-close" (click)="closeActivityDetail()"><i class="fa fa-close"></i></button>
        <p class="dv2-drawer-eyebrow">{{ 'schoolActivities' | translate }}</p>
        <h3>{{ viewActivityClassNumber }} - {{ viewActivityClassSection }}</h3>
      </div>

      <div class="dv2-drawer-tabs">
        <button type="button" class="dv2-tab" [class.active]="activityDetailTab === 'overview'" (click)="activityDetailTab = 'overview'">
          {{ 'classOverview' | translate }}
        </button>
        <button type="button" class="dv2-tab" [class.active]="activityDetailTab === 'activities'" (click)="activityDetailTab = 'activities'">
          {{ 'activityPosted' | translate }}
        </button>
      </div>

      <div class="dv2-drawer-body" *ngIf="activityDetailTab === 'overview'">
        <div class="dv2-stat-grid">
          <div class="dv2-stat-card dv2-stat-danger">
            <p><i class="fa fa-users"></i> {{ 'students' | translate }}</p>
            <h2>{{ viewActivityTotalStudent }}</h2>
            <span>{{ 'totalCount' | translate }}</span>
          </div>
          <div class="dv2-stat-card dv2-stat-warning">
            <p><i class="fa fa-check-square-o"></i> {{ 'attendance' | translate }}</p>
            <h2>{{ viewActivityAttendence }}/{{ viewActivityTotalStudent }}</h2>
            <span>{{ 'strength' | translate }}</span>
          </div>
          <div class="dv2-stat-card dv2-stat-success">
            <p><i class="fa fa-money"></i> {{ 'feesCollected' | translate }}</p>
            <h2>{{ 'rs' | translate }}. {{ viewActivityFeesCollected || 0 }}</h2>
            <span>{{ 'collected' | translate }}</span>
          </div>
          <div class="dv2-stat-card dv2-stat-neutral">
            <p><i class="fa fa-file-o"></i> {{ 'diaries' | translate }}</p>
            <h2>{{ viewActivityDiaries }}</h2>
            <span>{{ 'notes' | translate }}</span>
          </div>
        </div>

        <div class="dv2-teacher-card">
          <p class="dv2-teacher-title"><i class="fa fa-user"></i> {{ 'classTeachers' | translate }}</p>
          <ul *ngIf="viewActivityTeacher1 && viewActivityTeacher2 && viewActivityTeacher3" class="dv2-teacher-list">
            <li *ngIf="viewActivityTeacher1">{{ viewActivityTeacher1 }}</li>
            <li *ngIf="viewActivityTeacher2">{{ viewActivityTeacher2 }}</li>
            <li *ngIf="viewActivityTeacher3">{{ viewActivityTeacher3 }}</li>
          </ul>
          <div *ngIf="!(viewActivityTeacher1 && viewActivityTeacher2 && viewActivityTeacher3)" class="dv2-teacher-empty">
            {{ 'thereAreNoClassTeachers' | translate }}
          </div>
        </div>
      </div>

      <div class="dv2-drawer-body" *ngIf="activityDetailTab === 'activities'">
        <div *ngIf="!feedCount" class="dv2-empty">
          <i class="fa fa-file-excel-o"></i>
          <h3>{{ 'noResults' | translate }}</h3>
          <p>{{ 'weSearchForAndWideAndCouldntFindAnyFilesMatching' | translate }}</p>
        </div>

        <div *ngIf="feedCount" class="dv2-feed-list">
          <div class="dv2-feed-item" *ngFor="let feed of getgetClassFeedListArray">
            <img *ngIf="feed.media.length" class="dv2-feed-media" [src]="feed.media[0].MediaUrl" />
            <div class="dv2-feed-content">
              <div class="dv2-feed-author">
                <i class="glyphicon glyphicon-user"></i>
                <div>
                  {{ feed.staffName }}
                  <small>{{ feed.designation }} <i class="fa fa-clock-o"></i> {{ feed.CreatedOn | date : 'yMMMd' }}</small>
                </div>
              </div>
              <p class="dv2-feed-desc">{{ feed.Description }}</p>
              <div class="dv2-feed-meta">
                <span><i class="fa fa-thumbs-o-up"></i> {{ feed.TotalLikesCount }} {{ 'likes' | translate }}</span>
                <span><i class="fa fa-comment-o"></i> {{ feed.TotalCommentsCount }} {{ 'comments' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
